// extracted by mini-css-extract-plugin
module.exports = {"editIcon":"CartProductEdit_editIcon__2-GYD","link":"CartProductEdit_link__3ABSS"};